import { Injectable } from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap/datepicker';
import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';
import customParseFormat from 'dayjs/plugin/customParseFormat';

@Injectable()
export class NgbDateMomentParserFormatter extends NgbDateParserFormatter {
  private dayjs = dayjs;
  private readonly dateFormat: string;
  constructor() {
    super();
    dayjs.extend(objectSupport);
    dayjs.extend(customParseFormat);
    this.dateFormat = 'MMM D, YYYY';
  }
  public format(date: NgbDateStruct): string {
    if (date === null) {
      return '';
    }
    const d = this.dayjs({
      date: date.day,
      month: date.month - 1,
      year: date.year,
    });
    return d.isValid() ? d.format(this.dateFormat) : '';
  }

  public parse(value: string): NgbDateStruct {
    if (!value) {
      return null;
    }
    const d = this.dayjs(value) || this.dayjs(value, this.dateFormat);
    if (d.isValid()) {
      return {
        day: d.date(),
        month: d.month() + 1,
        year: d.year(),
      };
    }
  }
}
